import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchSiteContent() {
  const response = await axios.get(`${API_BASE}/content`);
  return response.data.content || {};
}

export async function loginAdmin(email, password) {
  const response = await axios.post(`${API_BASE}/admin/login`, { email, password });
  return response.data;
}

export async function fetchAdminContent(token) {
  const response = await axios.get(`${API_BASE}/admin/content`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.content || {};
}

export async function saveAdminContent(token, content) {
  const response = await axios.put(
    `${API_BASE}/admin/content`,
    { content },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}